import { useMemo } from "react";
import { FiltersOutput } from "@business-finland/wif-ui-lib/dist/Filters";
import { useRouter } from "next/router";

import useQuery from "@/hooks/useQuery";

export const useServicesQuery = (
  filtersValues: FiltersOutput,
  page = 1,
  limit = 4,
  displayOnlyChildrenPages?: boolean,
  currentPagePath?: string
) => {
  const { locale } = useRouter();
  const offset = (page - 1) * limit;
  
  const query = useMemo(() => {
    const params = new URLSearchParams(filtersValues);
    params.append("lang", locale || "en");
    params.append("offset", offset.toString());
    params.append("limit", limit.toString());
    
    if (displayOnlyChildrenPages !== undefined) {
      params.append("displayOnlyChildrenPages", displayOnlyChildrenPages.toString());
    }
    
    if (currentPagePath) {
      params.append("currentPagePath", currentPagePath);
    }
    
    return "?" + params.toString();
  }, [filtersValues, locale, offset, limit, displayOnlyChildrenPages, currentPagePath]);

  const { data, isLoading } = useQuery<Wif.Mgnl.Results<Wif.Mgnl.ServicePage>>(
    "/api/services" + query,
    {}
  );

  const totalCount = data?.total || 0;
  const pageCount = Math.ceil(totalCount / limit);

  return {
    isLoading,
    services: data?.results || [],
    totalCount,
    pageCount,
  };
}; 